<template>
  <div class="box">
    <div class="nav">
      <span :class="active === 0 ? 'active' : ''" @click="active = 0"
        >意见反馈</span
      >
      <span :class="active === 1 ? 'active' : ''" @click="active = 1"
        >我的反馈</span
      >
    </div>
    <!-- 意见反馈 -->
    <div v-if="active === 0" class="opinion">
      <h4>问题描述&nbsp;&nbsp;<span>*</span></h4>
      <div class="title">
        <input
          type="text"
          class="titleInput"
          placeholder="请输入标题"
          v-model="title"
        />
        <span
          ><b :style="title.length > 30 ? 'color: red;' : ''">{{
            title.length
          }}</b>
          / 30</span
        >
      </div>
      <Input
        class="content"
        v-model="content"
        :autosize="true"
        type="textarea"
        placeholder="请输入具体描述"
      />
      <div class="imgUplode">
        <div
          class="demo-upload-list"
          v-for="(item, index) in attachmentList"
          :key="index"
        >
          <img v-lazy="$global.imgUrl + item.fileUri" alt="" />
          <div class="demo-upload-list-cover">
            <Icon
              type="ios-trash-outline"
              @click.native="removePhotos(index)"
            />
          </div>
        </div>
        <Upload
          class="photoUplode"
          ref="upload"
          type="drag"
          accept=".png, .jpg, .jpeg"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :headers="{ token: token }"
          :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
          :show-upload-list="false"
          :on-exceeded-size="beyondSize"
          :on-success="PhotoUplode"
          :before-upload="beforeUplode"
        >
          <div class="photoUplodeBox">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <div class="tishi1">
          图片（支持JPG、JPEG、PNG格式，图片不超过 2M）{{
            "(" + attachmentList.length + "/5)"
          }}
        </div>
      </div>
      <div style="text-align: center; margin-top: 100px">
        <Button v-throttleClick class="submit" @click="submit">提交反馈</Button>
      </div>
    </div>
    <!-- 我的反馈 -->
    <div v-else class="opinion">
      <div
        class="listItem"
        v-for="item in list"
        :key="item.id"
        @click="toDetail(item.id)"
      >
        <span>{{ item.title }}</span>
        <span class="time">{{ item.createTime }}</span>
      </div>
      <Page
        :total="total"
        :current="pageNo"
        show-total
        :styles="{
          textAlign: 'center',
          marginTop: '60px',
          marginBottom: '50px',
        }"
        @on-change="pageChange"
      />
      <Modal
        width="500"
        class-name="modal"
        v-model="showDetail"
        :footer-hide="true"
        @on-cancel="closeModal"
      >
        <p class="modal-title">{{ modalTitle }}</p>
        <p class="modal-content">{{ modalContent }}</p>
        <div class="modal-img">
          <img
            v-for="item in modalImgList"
            :key="item.fileUri"
            v-lazy="$global.imgUrl + item.fileUri"
            alt=""
          />
        </div>
        <p class="modal-title">反馈结果：</p>
        <p class="modal-content">{{ modalResult }}</p>
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showDetail: false,
      active: 0,
      title: "",
      content: "",
      attachmentList: [],
      list: [],
      modalTitle: "",
      modalContent: "",
      modalImgList: [],
      modalResult: "",
      pageNo: 1,
      total: 0,
    };
  },
  watch: {
    active: {
      handler(newValue) {
        if (newValue === 1) this.getList();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["token"]),
  },
  methods: {
    closeModal() {
      (this.modalTitle = ""),
        (this.modalContent = ""),
        (this.modalResult = ""),
        (this.modalImgList = []);
    },
    // 查看详情
    async toDetail(id) {
      const resp = await this.$apis.userServe.feedbackDetail({
        feedbackId: id,
      });
      console.log(resp);
      this.showDetail = true;
      this.modalTitle = resp.data.title;
      this.modalContent = resp.data.content;
      this.modalResult = resp.data.result
        ? resp.data.result
        : "正在处理中，请稍后";
      this.modalImgList = resp.data.attachmentList
        ? [...resp.data.attachmentList]
        : [];
    },
    // 跳转页面
    pageChange(page) {
      this.pageNo = page;
      this.getList();
    },
    // 我的反馈列表
    async getList() {
      const { data } = await this.$apis.userServe.feedbackList({
        pageNo: this.pageNo,
        pageSize: 10,
      });
      this.list = [...data.list];
      this.total = +data.total;
    },
    // 提交意见反馈
    async submit() {
      if (this.title === "") {
        this.$Message.warning("请填写标题");
        return;
      } else if (this.title.length > 30) {
        this.$Message.warning("标题字数过多");
        return;
      } else if (this.content === "") {
        this.$Message.warning("请输入具体描述");
        return;
      }
      let obj = {
        title: this.title,
        content: this.content,
        attachmentList: this.attachmentList,
      };
      const resp = await this.$apis.userServe.subFeedback(obj);
      if (resp.resultCode === "200") {
        this.$Message.success("提交成功");
        this.title = "";
        this.content = "";
        this.attachmentList = [];
      }
    },
    // 超出文件上传大小
    beyondSize(file) {
      this.$Message.warning({
        content: file.name + " 文件大小超出限制,请重新上传",
        duration: 2,
      });
    },
    // 图片上传之前
    beforeUplode() {
      if (this.attachmentList.length >= 5) {
        this.$Notice.warning({
          title: "上传图片已达上限",
          duration: 1.5,
        });
        return false;
      }
    },
    // 上传成功
    PhotoUplode(res) {
      let obj = {
        fileName: "",
        fileUri: res.content.url,
      };
      this.attachmentList.push(obj);
    },
    // 删除照片
    removePhotos(index) {
      this.attachmentList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  .nav {
    margin: 28px 0;
    padding-left: 40px;
    span {
      margin-right: 63px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333;
      line-height: 48px;
      cursor: pointer;
    }
    .active {
      color: #263d78;
    }
  }
  .opinion {
    padding: 45px;
    width: 100%;
    min-height: 730px;
    border: 1px solid #a3cbe7;
    border-radius: 10px;
    background-color: #fff;
    h4 {
      margin-bottom: 60px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      span {
        color: red;
        vertical-align: middle;
      }
    }
    .title {
      margin-bottom: 48px;
      position: relative;
      width: 100%;
      height: 65px;
      border-bottom: 1px solid #dcdcdc;
      .titleInput {
        padding-bottom: 29px;
        padding-right: 50px;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 400;
      }
      span {
        position: absolute;
        top: 5px;
        right: 0;
        b {
          font-weight: 400;
        }
      }
    }
  }
  .content {
    &::v-deep .ivu-input {
      border: none;
      outline: none;
    }
    width: 100%;
    font-size: 14px;
    overflow: visible;
  }
  .imgUplode {
    margin-top: 30px;
    .photoUplode {
      display: inline-block;
      width: 134px;
      height: 134px;
      .ivu-upload {
        width: 100%;
        height: 100%;
        .photoUplodeBox {
          width: 100%;
          height: 100%;
          line-height: 134px;
        }
      }
    }
    .demo-upload-list {
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-right: 4px;
      width: 134px;
      height: 134px;
      text-align: center;
      line-height: 134px;
      border: 1px solid transparent;
      border-radius: 4px;
      background: #fff;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
      img {
        width: 100%;
        height: 100%;
      }
      .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        i {
          margin: 0 2px;
          color: #fff;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
    .demo-upload-list:hover .demo-upload-list-cover {
      display: block;
    }
  }
  .submit {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #007fff;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .listItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 65px;
    line-height: 65px;
    border-bottom: 1px dotted #a0a0a0;
    cursor: pointer;
    span {
      font-size: 14px;
      font-family: PingFang SC;
      color: #333333;
    }
    .time {
      color: #666;
    }
    &:nth-last-of-type(1) {
      border: none;
    }
  }
}
::v-deep .ivu-modal-content {
  padding: 30px 0px;
  .ivu-modal-close {
    width: 0;
    height: 0;
    border-width: 13px;
    border-style: solid;
    border-color: #969696 #969696 transparent transparent;
    top: 0;
    right: 0;
    overflow: inherit;
    .ivu-icon-ios-close {
      font-size: 20px;
      color: #fff;
      top: -16px;
      right: 5px;
    }
  }
  .ivu-modal-body {
    overflow-y: auto;
    height: 600px;
  }
  .modal-title {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    color: #333333;
  }
  .modal-content {
    margin-bottom: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    color: #666666;
  }
  .modal-img {
    margin-bottom: 22px;
    img {
      margin-right: 18px;
      width: 90px;
      height: 90px;
      border: 1px solid #dcdcdc;
      border-radius: 10px;
    }
  }
}
</style>